import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f03a950"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "8",
  y1: "12",
  x2: "16",
  y2: "12"
}, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" HEALTH ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "12",
  y1: "8",
  x2: "12",
  y2: "16"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "8",
  y1: "12",
  x2: "16",
  y2: "12"
}, null, -1))
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", { points: "16 12 12 8 8 12" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "12",
  y1: "16",
  x2: "12",
  y2: "8"
}, null, -1))
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("polyline", { points: "8 12 12 16 16 12" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "12",
  y1: "8",
  x2: "12",
  y2: "16"
}, null, -1))
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "health" }
const _hoisted_19 = { class: "armor" }
const _hoisted_20 = { class: "flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HealthBars = _resolveComponent("HealthBars")!
  const _component_Armor = _resolveComponent("Armor")!
  const _component_LabeledBox = _resolveComponent("LabeledBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LabeledBox, null, {
      title: _withCtx(() => [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (_ctx.editMode)
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 0,
                  class: _normalizeClass(["max-health-btn minus button", _ctx.disableDecreaseMaxHealth()]),
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.decreaseMaxHealth && _ctx.decreaseMaxHealth(...args))),
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, _hoisted_4, 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _hoisted_5,
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (_ctx.editMode)
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 0,
                  class: _normalizeClass(["max-health-btn plus button", _ctx.disableIncreaseMaxHealth()]),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.increaseMaxHealth && _ctx.increaseMaxHealth(...args))),
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "16",
                  height: "16",
                  viewBox: "0 0 24 24",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, _hoisted_9, 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (_ctx.editMode)
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 0,
                  class: _normalizeClass(["max-health-btn up button", _ctx.disableIncreaseMaxWounds()]),
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.increaseMaxWounds && _ctx.increaseMaxWounds(...args))),
                  viewBox: "0 0 24 24",
                  width: "16",
                  height: "16",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, _hoisted_13, 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (_ctx.editMode)
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 0,
                  class: _normalizeClass(["max-health-btn down button", _ctx.disableDecreaseMaxWounds()]),
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.decreaseMaxWounds && _ctx.decreaseMaxWounds(...args))),
                  viewBox: "0 0 24 24",
                  width: "16",
                  height: "16",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, _hoisted_17, 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_HealthBars)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_Armor)
          ])
        ])
      ]),
      _: 1
    })
  ]))
}